import React from "react";
import { STATUS } from "utils/constants";

interface StatusBadgeProps {
  status: string;
}

const StatusBadge = ({ status }: StatusBadgeProps) => {
  const statusText = STATUS[status] || status;
  const getStatusStyle = (status: string) => {
    switch (status) {
      case "SUCCESS":
        return "bg-green-100 text-green-800 border-green-200";
      case "PENDING":
      case "POSTPONED":
        return "bg-blue-100 text-blue-800 border-blue-200";
      case "IN_PROGRESS":
      case "PARTIAL_SUCCESS":
      case "PENDING_PROCESSING":
      case "PENDING_REVIEW":
      case "PENDING_MANUAL_CALL":
        return "bg-yellow-100 text-yellow-800 border-yellow-200";
      case "UNSUCCESSFUL":
        return "bg-red-100 text-red-800 border-red-200";
      case "INVALID":
        return "bg-gray-100 text-gray-800 border-gray-200";
      case "CANCELLED":
        return "bg-orange-100 text-orange-800 border-orange-200";
      default:
        return "bg-gray-100 text-gray-800 border-gray-200";
    }
  };

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${getStatusStyle(
        status
      )}`}
    >
      {statusText}
    </span>
  );
};

export default StatusBadge;
